<template>

	<div class="gallery-upload">

		<page-bar />

		<h3 class="page-title" v-translate>Álbum <span v-if="dataUpload.title">- {{dataUpload.title}}</span></h3>

		<div class="portlet light m-t-24">

			<div class="portlet-title">

				<div class="row">

					<div class="col-md-12">

						<router-link to="/gallery" class="btn btn-default btn-sm font-grey-cascade"><i class="fa fa-angle-left" aria-hidden="true"></i>  Voltar</router-link>

					</div>

				</div>

				<div class="row">
					<div class="col-md-4">
						<label v-translate>Nome do álbum:</label>
						<input type="text" class="form-control" v-model="dataUpload.title" placeholder="Digite o nome do álbum">
					</div>

					<div class="col-md-8">
						<label v-translate>Descrição do álbum:</label>
						<input type="text" class="form-control" v-model="dataUpload.description" placeholder="Digite a descrição do álbum">
					</div>

				</div>

				<div id="assign-photo">

					<h5 class="m-t-20" v-translate>A quem você deseja atribuir o álbum?</h5>

					<div class="row">

						<div class="col-md-4">
							<label v-translate>Selecione:</label>
							<select class="form-control" name="viewersGallery" v-model="viewersGalleryType" :disabled="album.id">
								<option v-for="(value, index) in ENUM.viewersGalleryType" :value="index">{{ value }}</option>
							</select>
						</div>

						<div class="col-md-4" v-if="viewersGalleryType == 'SCHOOL_CLASS'">
							<class-list :multiple="true" :label="'Turmas:'" :context="'gallery'" :disabled="album.id ? true : false"/>
						</div>

						<div class="col-md-4" v-if="viewersGalleryType == 'STUDENT'">
							<class-list :label="'Turma:'" :multiple="false" :context="'gallery'" :disabled="album.id ? true : false"/>
						</div>

						<students v-if="viewersGalleryType == 'STUDENT'" :class="'col-md-4'" :context="'gallery'" :imglist="false" :disabled="album.id ? true : false"/>

					</div>

					<div class="row">



						<div class="col-md-12">
							<button type="button" class="btn yellow-gold m-t-24 pull-right" @click="createAlbum(dataUpload)" v-if="!(album.id)">
								<span v-translate>Criar álbum</span>
							</button>

							<button type="button" class="btn yellow-gold m-t-24 pull-right" @click="createAlbum(dataUpload)" v-if="album.id">
								<span v-translate>Editar álbum</span>
							</button>
						</div>

						<div class="col-md-12" v-if="album.id">

							<button type="button" v-if="album.status == 'APPROVED'" class="btn red m-t-24 pull-right" @click="unpublish(album.id)">
								<i class="fa fa-times" aria-hidden="true"></i>
								<span  v-translate>Despublicar todas as fotos</span>
							</button>

							<button type="button" v-if="album.status != 'APPROVED'" class="btn green-jungle m-t-24 pull-right" @click="publish(album.id)">
								<i class="fa fa-paper-plane" aria-hidden="true"></i>
								<span v-translate>Publicar todas as fotos</span>
							</button>
						</div>

					</div>

				</div>

			</div>

			<div class="portlet-body m-t-24" >

				<div class="row" v-if="album.id">
					<div class="col-md-12 text-center">
						<upload class="upload-demo" drag :action="`/api/v1/gallery/user/${getLoggedUser.id}`" :data="dataUploadStringify()" :on-success="upload" name="files" multiple accept="image/*">
							<i class="el-icon-upload"></i>
							<div class="el-upload__text" v-translate>Arraste ou <em>clique para adicionar imagens</em></div>
							<div class="el-upload__tip" slot="tip" v-translate>Recomendamos que sejam utilizadas imagens menores que 500kb para que não haja lentidão no carregamento.</div>
						</upload>
					</div>
				</div>

				<hr v-if="album.photos">

				<div class="row" v-if="album.photos">
					<div class="col-md-10 pull-left">
						<h4 v-translate>Fotos</h4>
					</div>




				</div>

				<div class="row" v-if="album.photos">

					<div class="col-md-3">

						<button type="button" class="btn green-jungle m-b-10" @click="publishPhotoItem">
							<i class="fa fa-paper-plane" aria-hidden="true"></i>
							<span  v-translate>Publicar fotos selecionadas</span>
						</button>

					</div>

					<div class="col-md-3">

						<button type="button" class="btn red m-b-10" @click="unpublishPhotoItem">
							<i class="fa fa-user" aria-hidden="true"></i>
							<span  v-translate>Despublicar fotos selecionadas</span>
						</button>

					</div>

				</div>

			</div>

			<br>

			<div class="row" v-if="album.photos">
				<div class="col-md-2">
					<a class="font-grey-cascade" @click="selectAllPhotos" v-translate>Selecionar todas as fotos</a>
				</div>
				<div class="col-md-10">
					<a class="font-grey-cascade" @click="unselectAllPhotos" v-translate>Remover seleção das fotos</a>
				</div>

			</div>

			<div class="row" v-if="album.photos" v-masonry transition-duration="0.3s" item-selector=".item">

				<div v-masonry-tile class="col-md-6 card item" v-for="(photo, index) in album.photos">

					<card :body-style="{ padding: '0px' }">

						<div class="row">

							<div class="col-md-12 mt-element-ribbon m-b-0">
								<small v-if="!photo.publishedDateTime" class="ribbon ribbon-color-danger" v-translate>NÃO PUBLICADA</small>
								<small v-if="photo.publishedDateTime" class="ribbon ribbon-color-success" v-translate>Publicada às {{photo.publishedDateTime | date("HH:mm - DD/MM/YYYY")}}</small><br>
							</div>

						</div>

						<div class="row p-15">

							<div class="col-md-1 form-group">
								<label class="mt-checkbox mt-checkbox-single mt-checkbox-outline">
									<input type="checkbox" class="checkboxes" @click="selectPhotos($event, photo)" :checked="isChecked(photo.id)">
									<span></span>
								</label>
							</div>

							<div class="col-md-3">
								<a :href="photo.fileURL">
									<img :src="photo.thumbnailURL" class="image">
								</a>
							</div>

							<div class="col-md-7 form-group">
								<input type="text" class="form-control m-b-10" v-model="photo.title" @change="changeInfoPhoto(photo.id, photo.title, photo.description)" placeholder="Digite o título da foto">
								<input type="text" class="form-control"  v-model="photo.description" @change="changeInfoPhoto(photo.id, photo.title, photo.description)" placeholder="Digite a descrição da foto">

							</div>

							<div class="col-md-1">
								<a title="Excluir foto" @click="deletePhoto(photo.id)"><i class="fa fa-trash font-red" aria-hidden="true"></i></a>
							</div>

						</div>
					</card>

				</div>

			</div>

			<div class="row m-t-25" v-if="album.photos">

				<div class="col-md-3">

					<button type="button" class="btn green-jungle m-b-10" @click="publishPhotoItem">
						<i class="fa fa-paper-plane" aria-hidden="true"></i>
						<span  v-translate>Publicar fotos selecionadas</span>
					</button>

				</div>

				<div class="col-md-3">

					<button type="button" class="btn red m-b-10" @click="unpublishPhotoItem">
						<i class="fa fa-user" aria-hidden="true"></i>
						<span  v-translate>Despublicar fotos selecionadas</span>
					</button>

				</div>
			</div>

			<div class="row" v-if="album.photos">

				<div class="col-md-10">

				</div>


				<div class="col-md-2 pull-rigth">

					<button type="button" v-if="album.status == 'APPROVED'" class="btn red m-t-24 pull-right" @click="unpublish(album.id)">
						<i class="fa fa-times" aria-hidden="true"></i>
						<span  v-translate>Despublicar todas as fotos</span>
					</button>

					<button type="button" v-if="album.status != 'APPROVED'" class="btn green-jungle m-t-24 pull-right" @click="publish(album.id)">
						<i class="fa fa-paper-plane" aria-hidden="true"></i>
						<span v-translate>Publicar todas as fotos</span>
					</button>

				</div>
			</div>

		</div>
	</div>



</div>
</template>

<script>

import Album from './';
export default Album;

</script>

<style lang="scss" scoped>

.col {
	top: 24px;
}

.image {
	width: 100%;
	display: block;
}

.image:hover {
	-webkit-transform: scale(1.15);
	-ms-transform: scale(1.15);
	transform: scale(1.15);
}

h5 {
	font-size: 16px;
}

h4 {
	font-size: 24px;
}

.el-card {
	margin-bottom: 30px;
	overflow: inherit;
}

.row{
	margin-bottom:5px;
}

small {
	margin-top: 8px;
	display: inline-block;
}

.fa-trash{
	font-size:22px;
}

.assign{
	border: 1px solid #eee;
	padding: 10px;
}

</style>



// WEBPACK FOOTER //
// album.vue?2bd5c642